<template>
    <section class="panel panel--content panel--grid-content panel--white gallery-panel masonry" :class="[options.width,options.orientation]" :cols="options.max_images_per_row">
        <div v-if="image_tags.length > 0" class="panel__body">
            <div class="gallery_tag_filter filter__select_div">
                <h3>Filter by tag:</h3>
                <select v-model="selected_tag" class="custom-select group-search form-control site-list_spacing show-dropdown">
                    <option v-for="tag in image_tags" :key="tag" :value="tag">
                        {{ capitalise_string(tag) }}
                    </option>
                </select>
            </div>
        </div>
        <div class="gallery-container" aria-label="Image gallery">
            <div v-for="(image, index) in filtered_images" :key="index" @click="open_modal(index)" class="gallery_image" :style="[ gallery_orientation ? { height: options.image_height + 'px' } : null ]">
                <img :src="image.src" :alt="image.title">
                <div class="image-overlay">
                    <p v-if="options.overlay_hover.title !== true" class="image-title">{{ image.title }}</p>
                    <p v-if="options.overlay_hover.description !== true" class="image-description">{{ image.description }}</p>
                </div>
            </div>
        </div>
        <div id="gallery-modal" class="gallery_modal" :class="show_modal == false ? 'hidden' : 'visible'" role="dialog" aria-label="Image gallery modal" :aria-modal="show_modal" style="z-index:999;">
            <div class="modal-inner-container">
                <div @click="close_modal" class="modal-background"></div>
                <div class="modal-content">
                    <span @click="close_modal" class="close">&times;</span>
                    <div class="image-container">
                        <img v-bind:src="selected_image_object.src" :alt="selected_image_object.title" aria-describedby="slide-caption" />
                    </div>
                    <figcaption>
                        <div class="mfp-bottom-bar">
                            <div v-if="options.modal_lightbox.title !== true" class="image-title">{{ selected_image_object.title }}</div>
                            <div v-if="options.modal_lightbox.description !== true" class="image-description">{{ selected_image_object.description }}</div>
                            <div class="mfp-counter">{{ selected_image_index + 1 }} / {{ filtered_images.length }}</div>
                            <div v-if="selected_image_object.tags !== null" class="image-tags">
                                <span v-for="tag in selected_image_object.tags" :key="tag" @click="modal_select_tag(tag)">
                                    {{ capitalise_string(tag) }}
                                </span>
                            </div>
                        </div>
                    </figcaption>
                </div>
                <a @click="previous_image()" class="prev_image"></a>
                <a @click="next_image()" class="next_image"></a>
            </div>
        </div>
    </section>
</template>

<script>
import mixins from '../mixins.js'

export default {
    props: {
        images: Array,
        tags: Array,
        flickr: Boolean,
        options: Array
    },
    mixins: [ mixins ],
    data() {
        return {
            selected_image_index: 0,
            selected_image_object: {
                src: null,
                title: null,
                description: null,
                tags: null
            },
            image_tags: [],
            filtered_images: [],
            selected_tag: 'All tags',
            show_modal: false
        }
    },
    computed: {
        gallery_orientation() {
            if(this.options.orientation == 'horizontal') {
                return true;
            }
            return false;
        }
    },
    watch: {
        selected_image_index() {
            // Load the image with the corresponding index
            this.selected_image_object = this.filtered_images[this.selected_image_index];
        },
        selected_tag() {
            if(this.selected_tag !== 'All tags') {
                // If a tag has been used run the filter
                this.filter_by_tag();
            } else {
                // If 'All tags' then use the original images array
                this.filtered_images = this.images;
            }
        }
    },
    methods: {
        modal_select_tag(tag){
            this.close_modal();
            this.selected_tag = tag;
        },
        filter_by_tag() {
            this.filtered_images = [];
            // Load the tag into a local variable
            let tag = this.selected_tag;
            // Load the original list data into a local variable
            let images_array = this.images;
            
            // Function to filter by the tags into each list item
            function filterByTag(item) {
                if(item.tags.includes(tag)) {
                    return true
                } 
                return false;
            }
            this.filtered_images = images_array.filter(filterByTag);
            // Set the modal image object to the first image. This stops it returning blank
            this.selected_image_object = this.filtered_images[0];
        },
        load_and_sort_tags() {
            // Load our tags prop data
            this.image_tags = this.tags;
            // Sort it alphabetically
            this.image_tags.sort();
            // And add 'All tags' at the start
            this.image_tags.unshift('All tags');
        },
        open_modal(index) {
            // Set our image for the modal
            this.selected_image_index = index;
            // Make the modal visible
            this.show_modal = true;
            // Now stop scrolling on the body
            document.body.style.overflow = "hidden";
            // Listen out for navigation controls
            document.addEventListener('keydown', this.modal_navigation_listener);
        },
        close_modal() {
            // Hide the modal
            this.show_modal = false;
            // Now stop scrolling on the body
            document.body.style.overflow = "visible";
            // Close the event listener
            document.removeEventListener("keydown", this.modal_navigation_listener);
        },
        previous_image() {
            if(this.selected_image_index == 0) {
                // If on the first slide go to the last
                this.selected_image_index = (this.filtered_images.length - 1)
            } else {
                // Else apply the -1
                this.selected_image_index = this.selected_image_index - 1
            }
        },
        next_image() {
            if (this.selected_image_index < (this.filtered_images.length - 1)) {
                // Less than the array total, add one
                this.selected_image_index = this.selected_image_index + 1
            } else {
                // Otherwise reset to 0
                this.selected_image_index = 0
            }
            // Note - The minus -1 for the filtered images ensures parity with the index value
        },
        modal_navigation_listener(event) {
            if(event.key == 'ArrowLeft' || event.keyCode == 37) {
                // Left arrow / Previous slide
                this.previous_image()
            }
            if(event.key == 'ArrowRight' || event.keyCode == 39) {
                // Right arrow / Next slide
                this.next_image()
            }
            if(event.key == 'Escape' || event.keyCode == 27) {
                // Close the modal
                this.close_modal()
            }
        }
    },
    created() {
        this.selected_image_index = 1;
        this.filtered_images = this.images;
        if(this.tags.length > 0) {
            this.load_and_sort_tags();
        }
    },
    beforeDestroy() {
        localStorage.removeItem('galleryArray');
    }
}
</script>